import OpenInNewIcon from "@mui/icons-material/OpenInNew";

import { defaultButton, defaultDescription, defaultId, defaultName, defaultStatus, defaultStatusMsg, defaultStyle, defaultThumbnail, defaultTime, defaultType } from "./shared.js";
import { isEmpty } from "../shared/miscUtils.js";

// Custom functions for table columns.
const getThumbnail = (props, params) => {
    return params.row?.meta_data?.thumbnail;
};

const urlTitle = (props, params) => {
    return "Source";
};

const clickUrl = (props, params) => {
    const url = params.row.url;
    window.open(url, "_blank");
};

const disableUrl = (props, params) => {
    const url = params.row.url;
    return !url;
};

const actionTitle = (props, params) => {
    const transcript = props?.backend?.transcripts?.data?.find((t) => t.resource_id === params.row.id) || {};
    return transcript?.status === "PROCESSED" ? "View" : "Edit";
};

const clickAction = (props, params) => {
    const transcript = props?.backend?.transcripts?.data?.find((t) => t.resource_id === params.row.id) || {};
    const cmd = transcript?.status === "PROCESSED" ? "view" : "edit";
    props.browser.navigate(`/database/transcripts/${transcript.id}/${cmd}`);
};

const disableAction = (props, params) => {
    const transcript = props?.backend?.transcripts?.data?.find((t) => t.resource_id === params.row.id);
    return isEmpty(transcript) || params.row.status !== "PROCESSED";
};

// Column definitions.
const name = { ...defaultName, minWidth: 150 };
const description = { ...defaultDescription, minWidth: 200 };
const authors = {
    ...defaultStyle,
    field: "author.last_name",
    headerName: "Authors",
    flex: 0.1,
    minWidth: 100,
    valueGetter: (params) => params.row.authors.map((a) => `${a.first_name} ${a.last_name}`).join(", ")
};
const library = {
    ...defaultStyle,
    field: "library.name",
    headerName: "Library",
    flex: 0.1,
    minWidth: 100,
    valueGetter: (params) => params.row.library?.name
};
const uploadedOn = { ...defaultTime("uploaded_on"), headerName: "Uploaded on" };
const createdOn = { ...defaultTime("created_on"), headerName: "Created on" };
const updatedOn = { ...defaultTime("updated_on"), headerName: "Updated on" };
const status = { ...defaultStatus() };
const statusMsg = { ...defaultStatusMsg };
const type = { ...defaultType };
const thumbnail = (props) => {
    return { ...defaultThumbnail(props, { thumbnail: getThumbnail }), minWidth: 100, flex: 0.1 };
};
const url = (props) => {
    return {
        ...defaultButton(props, { onClick: clickUrl, disabled: disableUrl, title: urlTitle, endIcon: <OpenInNewIcon />, variant: "outlined" }),
        field: "url",
        headerName: "URL",
        minWidth: 105,
        flex: 0.1
    };
};
const action = (props) => {
    return { ...defaultButton(props, { onClick: clickAction, disabled: disableAction, title: actionTitle }), minWidth: 75, flex: 0.1 };
};

// Table columns.
export const columns = (props) => [
    defaultId,
    name,
    description,
    thumbnail(props),
    authors,
    library,
    status,
    type,
    url(props),
    uploadedOn,
    createdOn,
    updatedOn,
    statusMsg,
    action(props)
];

// Style and other misc. functions.
export const isRowSelectable = (props, params) => {
    return true;
};

// Default aggregate props of the table.
export const defaultTableOptions = {
    isRowSelectable,
    checkboxSelection: true
};
